<template>
    <div class="login-form" full-height>
        <!-- <dialog-language ref="ref_dialogLanguage"></dialog-language> -->
        <!-- <v-alert icon="info_outline" style="background-color: rgba(66, 165, 245, 0.15); text-align: center;" class="mb-0" :value="true">
            Lifetime <strong>Free</strong> access for single business use
        </v-alert> -->

        <div v-if="$root.selectedLanguage" style="background-color: rgba(66, 165, 245, 0.15);font-size: 14px;" class="pt-3 pb-3 pl-4 -r-4">
            <img class="mr-4" src="../../assets/icon_info.svg" alt="_" style="float: left;">
            <div style="padding-top: 2px;" v-html="$t('login.lifetimeFreeBanner')"></div>
        </div>

        <div style="text-align: right; padding: 4px 8px 0;">
            <v-btn small text class="primary-color" @click="fn_goBack('back')">
                {{ fn_currentLangLabel() }} <v-icon small>arrow_drop_down</v-icon>
            </v-btn>
        </div>

        <!-- <v-btn color="success" @click="fn_test">text</v-btn> -->

        <v-card noshadow>
            <v-card-text style="padding-top: 24px;">
                <v-form class="form-element">
                    <v-layout v-if="trueCallerUser === false" align-center nomargin row wrap style="max-width:400px;margin: auto !important;">

                            <!-- <p class="title mb-2" style="line-height:28px !important">
                                Enter Mobile Number
                            </p> -->

                            <p class="title" style="line-height:32px !important;font-size: 1.5rem !important;color: rgba(0,0,0,0.87);">
                                {{ $t('login.enterMobileTitle') }}
                            </p>

                            <!-- <p>We will send an OTP on mentioned mobile number</p> -->
                            <p class="mb-6" style="font-size: 1rem; color: rgba(0,0,0,0.54);">{{ $t('login.enterMobileSubtitle') }}</p>

                            <v-flex xs12 sm12 md12 mb-6 nopadding>
                               <v-text-field type="tel"  
                                    id="mobile_number_field"
                                    v-model="Form.mobileNumber" 
                                    flat
                                    outlined
                                    solo
                                    prefix="+91"
                                    hide-details
                                    placeholder=" "
                                    v-validate="'required|numeric|min:10|max:10'"
                                    :maxlength="10"
                                    data-vv-name="mobile" 
                                    data-vv-as="mobile number" 
                                    required>
                                </v-text-field>
                            </v-flex>

                            <!-- <v-flex xs12 sm12 md12 margin-top-ten nopadding right-align>
                               <v-btn color="primary" nomargin @click="fn_checkValidation">Send OTP</v-btn>
                            </v-flex> -->

                            <v-flex xs12 sm12 md12 center-align>
                                <v-btn color="primary" class="mb-2" style="height:54px;font-size: 1rem;border-radius: 10px;" block @click="fn_checkValidation" v-if="trueCallerUser === false">{{ $t('login.continueBtn') }}</v-btn>
                                <!-- <div grey-color class="pa-4">By login, I accept the <span @click="fn_openTerms"><u>Terms &amp; Conditions</u></span></div> -->
                                <div class="pa-4" font14 style="letter-spacing: 1px;color: green;font-weight: 500;"><span style="font-size: 20px;">&#128274;</span> {{ $t('login.safeAndSecure') }}</div>
                            </v-flex>

                        </v-layout>
                </v-form>
            </v-card-text>

            <v-card-text style="padding-top: 24px;" v-if="trueCallerUser === true">
                <v-layout align-center nomargin row wrap style="max-width:400px">

                    <!-- <p class="title grey-color" style="line-height:28px !important">
                        Verifying your number thru Truecaller
                    </p> -->
                    <p class="title" style="line-height:32px !important;font-size: 1.5rem !important;color: rgba(0,0,0,0.87);">
                        {{ $t('login.verifyingTruecaller') }}
                    </p>
                </v-layout>
            </v-card-text>
        </v-card>

        <!-- <v-card flat>
            <v-card-text>
                <div style="font-size: 16px;background: #d4edda;padding: 8px 16px;width: fit-content;margin: auto;border-radius: 5px;color: #155724;letter-spacing: 2px;border: 1px #c3e6cb solid;font-weight: 500;"> <span style="font-size: 22px;font-weight: 600;">&check;</span> 100% Safe &amp; Secure</div>
            </v-card-text>
        </v-card>    -->

        <v-footer style="background:#fff" class="pa-3 bottom-fixed-footer" height-auto v-if="trueCallerUser === false">
             <v-flex xs12 sm12 md12 center-align @click="$root.fn_whatsAppSupport">
                <div class="pa-4" font14 style="letter-spacing: 0.5px;font-weight: 500;"><span style="color: #4b77be;"><img src="../../assets/icon_support.svg" style="width:20px;margin-bottom: -4px;"/> {{ $t('login.contactSupport') }}</span></div>
            </v-flex>
            <v-flex xs12 sm12 md12 center-align>
                <div grey-color>{{ $t('login.termsPrefix') }} <span @click="fn_openTerms" class="primary-color"><u>{{ $t('login.termsLink') }}</u></span> {{ $t('login.termsAnd') }} <span @click="fn_openPolicy" class="primary-color"><u>{{ $t('login.privacyLink') }}</u></span></div>
            </v-flex>
        </v-footer>

        <!-- <v-list two-line class="pa-0" style="position: absolute;bottom: 0;max-width: 400px;left: 0;right: 0;margin: auto;margin: 16px;">
            <v-list-item style="background: #f0f0f0;border-radius: 5px;min-height: 80px;">
                <v-list-item-avatar style="border-radius: 0;width: 100px;height: 54px;">
                    <v-img src="../../assets/RegistrationVideo_Thumbnail.jpg"></v-img>
                </v-list-item-avatar>
                <v-list-item-content>
                    <v-list-item-title style="font-size: 0.875rem;overflow: visible;white-space: normal;line-height: 1.3;" class="mb-2">How to login and register your business on BizOps App</v-list-item-title>
                    <v-list-item-sub-title style="font-size: 0.875rem;" primary-color>Watch Video</v-list-item-sub-title>
                </v-list-item-content>
                <v-list-item-action>
                    <v-icon style="background: #4b77be;border-radius: 50%;color: #fff;">chevron_right</v-icon>
                </v-list-item-action>
            </v-list-item>
        </v-list> -->
    </div>
</template>

<script>
    // import dialogLanguage from '../dialogs/dialog_language.vue'

    export default{
        // components: { 'dialog-language': dialogLanguage },
        data(){
            return{
                Form:{"mobileNumber":null},
                trueCallerUser:null,
                // trueCallerUser:false,
                loading:true,
                userName:''
            }
        },
        methods: {
            fn_openLanguageDialog: function(){
                this.$refs.ref_dialogLanguage && this.$refs.ref_dialogLanguage.openDialogWeb();
            },
            fn_currentLangLabel: function(){
                var map = { en: 'English', hinglish: 'Hinglish', hi: 'हिंदी' };
                return map[this.$root.selectedLanguage] || 'English';
            },
            // fn_onLanguageSelected: function(code){
            //     console.log('[login] language selected:', code);
            //     this.fn_getTrueCallerUser();   
            // },

            // test(){
            //     this.$router.push({path:'/registration/business/register', query:{'usertype':1}});
            // },

            fn_openTerms: function(){
                AndroidRoutingTest.openBrowser("https://bizopsapp.com/terms");
            },

            fn_openPolicy: function(){
                AndroidRoutingTest.openBrowser("https://bizopsapp.com/policy");
            },

            fn_isBusinessActive: function(){
                console.log("ActiveBusinessStatus");
                let self = this;
                this.getData('ActiveBusinessStatus', null, 
                {
                    onSuccess: function(response){
                        console.log(response);
                        let status = JSON.parse(response);
                        if(status.ActiveBusiness && status.DataDrive && status.DataRestore==null){
                            // if(self.$root.appVersion < 234){
                            //     self.$root.fn_loadMainApp(); 
                            // }
                            // else{
                            //     self.fn_getRestoreFlag(status.activeBusinessId);
                            // }
                            self.$root.fn_loadMainApp();
                        }
                        else if(status.ActiveBusiness && status.BusinessCount>0 && status.DataRestore==-1){
                            self.$router.replace({path:'/registration/business/restore_data', query:{activeBusinessId:status.activeBusinessId}});
                            /*global AndroidRoutingTest*/
                            AndroidRoutingTest.onPageLoadCompleted('1', JSON.stringify({}));
                        }
                        else{
                            AndroidRoutingTest.onPageLoadCompleted('1', JSON.stringify({}));
                            setTimeout(() => {
                                // self.fn_showTrueCallerDialog();
                                // // calling in case of login via true caller
                                self.fn_getTrueCallerUser();
                            });
                        }

                        let activeBusinessId = status.ActiveBusiness && status.activeBusinessId ? status.activeBusinessId : 'new_business';
                        let postObj = {"eventName":"page_load_complete","eventData":[{"eventKey":"active_business_id","eventValue":activeBusinessId}]}
                        self.$root.fn_postMetrics(postObj);
                    }, 
                    onError: function(error){
                        console.log(error);
                        self.showToast(self.$t('common.somethingWentWrong'));
                    }
                });
            },

            fn_checkValidation: function(){
                if(localStorage.getItem('limitExceededObj')){
                    let obj = JSON.parse(localStorage.getItem('limitExceededObj'));
                    if(obj.numbers.length >= 3){
                        let timeInMilliseconds = new Date() - new Date(obj.dateTime);
                        let timeInMinutes = Math.floor(timeInMilliseconds/1000/60);
                        if(timeInMinutes < 60){
                            this.showToast(this.$t('login.limitReached'));
                            return;
                        }
                        else{
                            localStorage.removeItem('limitExceededObj');
                        }
                    }
                }
                
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        
                        if(!navigator.onLine){
                            this.showToast(this.$t('common.internetNotAvailable'));
                            return;
                        }

                        this.fn_getOtp();
                    }
                    else{
                        this.showToast(this.$t('login.invalidMobile'));
                    }
                });
            },

            fn_getOtp: function(){
                this.$router.push({
                    name:'otpVerification', 
                    query:{mobile_number:this.Form.mobileNumber},
                    params: {
                        verifyCallback: this.fn_verifyCallback
                    }
                });
            },

            fn_verifyCallback: function(response, failureCallback){
                this.fn_signInUsingToken(response, failureCallback)
            },

            fn_getToken: function(response, failureCallback){
                if(!navigator.onLine){
                    this.showToast(this.$t('common.internetNotAvailable'));
                    return;
                }

                this.showLoading(this.$t('common.almostThere'));
                let self = this;
                this.$root.fn_getAuthToken(function(token){
                    token != 'error' ?  self.fn_login(token, failureCallback) : '';
                })
            },

            fn_login: function(token, failureCallback){
                if(!navigator.onLine){
                    this.showToast(this.$t('common.internetNotAvailable'));
                    return;
                }
                
                var self = this;
                let postObj = {};
                postObj.DeviceName = this.deviceInfo.DeviceName;
                postObj.AndroidVersion = this.deviceInfo.AndroidVersion;
                // postObj.FCMID = AndroidRoutingTest.getFcmId();
                postObj.FCMID = null;
                postObj.DeviceType = 1;
                postObj.token = token;

                // if(!postObj.FCMID){
                //     console.log("FCM Id not found!");
                //     this.showToast("Something went wrong. Try again!");
                //     this.hideLoading();
                //     return
                // }

                console.log(JSON.stringify(postObj));

                this.postServerData('Login', postObj, 
                    {
                        onSuccess: function(response){
                            console.log(response);

                            let businessData = JSON.parse(response);
                            if(!businessData.Business.length){
                                self.hideLoading();
                                self.fn_newBusiness();
                                // self.fn_userType();
                            }
                            else{
                                self.fn_confirmBusiness(businessData, token, failureCallback);
                            }
                        },
                        onError: function(error){
                            console.log(error);
                            self.hideLoading();
                            if(typeof JSON.parse(error) == 'object'){
                                let response = JSON.parse(error);
                                self.showToast(response.Message);
                            }
                            failureCallback ? failureCallback() : '';
                        }, 
                    }
                );
            },

            fn_confirmBusiness: function(businessData, token, failureCallback){
                
                var self = this;
                let postObj = {};
                let deviceId = AndroidRoutingTest.getDeviceId();
                postObj.DeviceID = deviceId ? deviceId : null;
                postObj.token = token;
                postObj.BusinessID = businessData.Business[0].BusinessID;
                postObj.IsRemote = businessData.Business[0].IsRemote;

                console.log(JSON.stringify(postObj));

                this.postServerData('ConfirmBusinessLogin', postObj, 
                    {
                        onSuccess: function(response){
                            console.log(response);
                            // let tokenData = JSON.parse(response);
                            // self.fn_signInUsingToken(tokenData.Token, null, businessData);
                            // self.hideLoading();
                            self.$root.CurrentBusiness = businessData.Business[0];
                            self.fn_saveBusinessToMaster(self.$root.CurrentBusiness);
                        }, 
                        onError: function(error){
                            console.log(error);
                            self.hideLoading();
                            if(typeof JSON.parse(error) == 'object'){
                                let response = JSON.parse(error);
                                self.showToast(response.Message);
                            }
                            failureCallback ? failureCallback() : '';
                        }, 
                    }
                );
            },

            // fn_userType: function(){
            //     this.$router.replace({path:'/registration/business/usertype', query:{"mobile_number":this.Form.mobileNumber, 'user_name':this.userName}});
            // },

            fn_newBusiness: function(){
                this.$router.replace({path:'/registration/business/register', query:{"mobile_number":this.Form.mobileNumber, 'user_name':this.userName}});
            },

            // fn_activateBusiness: function(businessData){
            //     this.$router.replace({
            //         name:"activateBusiness", 
            //         query:{
            //             businessId:businessData.BusinessID,
            //             businessName:businessData.BusinessName,
            //             mobileNumber:this.Form.mobileNumber
            //         }
            //     });
            // },

            fn_saveBusinessToMaster: function(business){
                let self = this;
                let postObj = JSON.parse(JSON.stringify(business));
                // postObj.CreatedOn = new Date(postObj.CreatedOn);
                // postObj.ModifiedOn = new Date(postObj.ModifiedOn);

                // if(!postObj.OpeningDate){
                //     let openingDate = new Date();
                //     postObj.OpeningDate = new Date((openingDate.getMonth() + 1) + '/1/' + openingDate.getFullYear());
                // }
                // else{
                //     let trimmedDate = postObj.OpeningDate.substring(0, postObj.OpeningDate.indexOf('T'));
                //     postObj.OpeningDate = new Date(trimmedDate); 
                // }
                
                // postObj.OpeningDate = new Date(postObj.OpeningDate);
                // saving opening date in camel case
                // postObj.openingDate = new Date(postObj.OpeningDate);
                // postObj.GSTRegistrationDate = postObj.GSTRegistrationDate ? new Date(postObj.GSTRegistrationDate) : null;
                postObj.OpeningDateValue = postObj.OpeningDateValue ? this.fn_getLocalDateFormat(postObj.OpeningDateValue) : null;
                postObj.CreatedOn = postObj.CreatedOn ? this.fn_getLocalDateFormat(postObj.CreatedOn) : null;
                postObj.ModifiedOn = postObj.ModifiedOn ? this.fn_getLocalDateFormat(postObj.ModifiedOn) : null;
                
                postObj.OpeningDate = this.fn_getLocalDateFormat(postObj.OpeningDate);
                postObj.isActive = 1;
                this.postData('SaveBusinessToMaster', postObj, 
                    {
                        onSuccess: function(response){
                            console.log(response);
                            if(self.$root.appVersion < 133){
                                self.fn_reopenDatabase(business, false);
                            }
                            else{
                                self.fn_checkDatabaseFile(business.BusinessID, (isDBFileExists)=>{
                                    if(business.DataDrive){
                                        self.hideLoading();
                                        self.$router.replace({path:'/registration/business/restore_data', query:{exitapp:1}});
                                    }
                                    else{
                                        self.fn_reopenDatabase(business, isDBFileExists); 
                                    }
                                    // self.fn_reopenDatabase(business, isDBFileExists);
                                })
                            }
                            // self.fn_reopenDatabase(business);
                        }, 
                        onError: function(error){
                            console.log(error);
                        }
                    }
                );
            },

            fn_getLocalDateFormat: function(dateObj){
                let now = dateObj ? new Date(dateObj) : new Date();
                let year = now.getFullYear();
                let month = ("0" + (now.getMonth()+1)).slice(-2);
                let date = ("0" + now.getDate()).slice(-2);
                let time = now.toTimeString().substring(0, now.toTimeString().indexOf(' '));
                return year + '-' + month + '-' + date + 'T' + time + '.' + now.getMilliseconds();
            },

            fn_reopenDatabase: function(business, isDBFileExists){
                let self = this;
                this.getData('ReopenDataBase', business.BusinessID, 
                    {
                        onSuccess: function(response){
                            console.log(response);
                            if(isDBFileExists && !localStorage.getItem('partial_restore')){
                                self.hideLoading();
                                self.$root.fn_loadMainApp();
                            }
                            else{
                                self.fn_saveBusinessDetail(business); 
                            }
                            // self.fn_saveBusinessDetail(business);
                        }, 
                        onError: function(error){
                            console.log(error);
                        }
                    }
                );
            },

            fn_saveBusinessDetail: function(business){
                let self = this;
                let postObj = JSON.parse(JSON.stringify(business));
                // postObj.CreatedOn = new Date(postObj.CreatedOn);
                // postObj.ModifiedOn = new Date(postObj.ModifiedOn);
                
                // if(!postObj.OpeningDate){
                //     let openingDate = new Date();
                //     postObj.OpeningDate = new Date((openingDate.getMonth() + 1) + '/1/' + openingDate.getFullYear());
                // }
                // else{
                //     let trimmedDate = postObj.OpeningDate.substring(0, postObj.OpeningDate.indexOf('T'));
                //     postObj.OpeningDate = new Date(trimmedDate);    
                // }
                
                // postObj.OpeningDate = new Date(postObj.OpeningDate);
                // postObj.openingDate = new Date(postObj.OpeningDate);
                // postObj.GSTRegistrationDate = postObj.GSTRegistrationDate ? new Date(postObj.GSTRegistrationDate) : null;

                postObj.OpeningDateValue = postObj.OpeningDateValue ? this.fn_getLocalDateFormat(postObj.OpeningDateValue) : null;
                postObj.CreatedOn = postObj.CreatedOn ? this.fn_getLocalDateFormat(postObj.CreatedOn) : null;
                postObj.ModifiedOn = postObj.ModifiedOn ? this.fn_getLocalDateFormat(postObj.ModifiedOn) : null;

                postObj.OpeningDate = this.fn_getLocalDateFormat(postObj.OpeningDate);
                postObj.isActive = 1;
                postObj.webVersion = 10;
                this.postData('SaveBusinessDetail', postObj, 
                    {
                        onSuccess: function(response){
                            console.log(response);
                            self.hideLoading();
                            if(JSON.parse(response)){
                                if(!self.$root.CurrentBusiness.DataDrive){
                                    // if(!self.$root.CurrentBusiness.IsAccountantOnly){
                                    if(!self.$root.CurrentBusiness.IsAccountantOnly || (self.$root.CurrentBusiness.IsAccountantOnly && (self.$root.CurrentBusiness.GSTRegistrationStatus == 1 || self.$root.CurrentBusiness.GSTRegistrationStatus == 2 || self.$root.CurrentBusiness.GSTRegistrationStatus == 3))){
                                        self.$root.fn_pushDefaultJson(function(){
                                            self.$root.fn_loadMainApp();
                                        });    
                                    }
                                    else{
                                        self.$root.fn_loadMainApp();
                                    }
                                }
                                else{
                                    self.$router.replace({path:'/registration/business/restore_data', query:{exitapp:1}});
                                }
                            }
                            else{
                                self.showToast(self.$t('common.somethingWentWrong'))
                            }
                        },
                        onError: function(error){
                            console.log(error);
                        },
                    }
                );
            },

            // fn_showTrueCallerDialog: function(){
            //     let self = this;
            //     this.getData('ShowTrueCallerDialog', null, 
            //         {
            //             onSuccess: function(response){
            //                 console.log(response);
            //                 // calling in case of login via true caller
            //                 self.fn_getTrueCallerUser();   
            //             }, 
            //             onError: function(error){
            //                 console.log(error);
            //             }
            //         }
            //     );
            // },

            // calling in case of login via true caller
            fn_getTrueCallerUser: function(){
                let self = this;
                this.getData('GetTrueCallerUser', null, 
                    {
                        onSuccess: function(response){
                            console.log(response);
                            self.trueCallerUser = JSON.parse(response);
                            if(self.trueCallerUser){
                                self.fn_getTrueCallerProfile();    
                            }
                            else{
                                self.fn_phoneNumberHint();
                            }
                            
                        }, 
                        onError: function(error){
                            console.log(error);
                            self.fn_phoneNumberHint();
                        }
                    }
                );
            },

            // calling in case of login via true caller
            fn_getTrueCallerProfile: function(){
                let self = this;
                this.getData('GetTrueCallerProfile', null, 
                    {
                        onSuccess: function(response){
                            console.log(response);
                            self.fn_formatProfileData(response);
                        }, 
                        onError: function(error){   
                            console.log(error);
                        }
                    }
                );
            },

            // calling in case of login via true caller
            fn_formatProfileData: function(response){
                let userProfile = JSON.parse(response);
                let tokenObj = {};
                tokenObj.Payload = userProfile.Payload;
                tokenObj.Signature = userProfile.Signature;
                tokenObj.accessToken = userProfile.accessToken;

                tokenObj.clientId = userProfile.clientId;
                tokenObj.codeVerifier = userProfile.codeVerifier;
                tokenObj.state = userProfile.state;

                this.userName = userProfile.userName;
                if(userProfile.PhoneNumber){
                    this.Form.mobileNumber = userProfile.PhoneNumber.substr(userProfile.PhoneNumber.length-10, userProfile.PhoneNumber);
                }
                
                this.fn_getCustomToken(tokenObj);
            },

            // calling in case of login via true caller
            fn_getCustomToken: function(dataObj){
                if(!navigator.onLine){
                    this.showToast(this.$t('common.internetNotAvailable'));
                    this.hideLoading();
                    return;
                }

                let self = this;
                this.showLoading(this.$t('common.pleaseWait'));
                this.postServerData('GetCustomToken', dataObj, 
                    {
                        onSuccess: function(response){
                            console.log(response);
                            let tokenData = JSON.parse(response);
                            self.fn_signInUsingToken(tokenData.Token);
                        }, 
                        onError: function(error){
                            console.log(error);
                            self.hideLoading();
                        }
                    }
                );
            },

            // fn_signInUsingToken: function(token, failureCallback, businessData){
            fn_signInUsingToken: function(token, failureCallback){
                if(!navigator.onLine){
                    this.showToast(this.$t('common.internetNotAvailable'));
                    this.hideLoading();
                    return;
                }

                let self = this;
                this.getData('SignInUsingToken', token, 
                    {
                        onSuccess: function(response){
                            console.log(response);
                            self.hideLoading();
                            // if(businessData){
                            //     self.$root.CurrentBusiness = businessData.Business[0];
                            //     self.fn_saveBusinessToMaster(self.$root.CurrentBusiness);
                            // }
                            // else{
                                self.fn_getToken(null, failureCallback);
                            // }
                        }, 
                        onError: function(error){
                            self.hideLoading();
                            self.showToast(self.$t('common.somethingWentWrong'));
                            console.log(error);
                        }
                    }
                );
            },

            fn_cancelSetOtp: function(otp){
                console.log(otp);
                console.log('screen got back!');
            },

            fn_phoneNumberHint: function(){
                let self = this;
                this.getData('ShowPhoneNumberHint', null, 
                    {
                        onSuccess: function(response){
                            console.log(response);
                            self.Form.mobileNumber = response.substring(response.length - 10, response.length);
                        }, 
                        onError: function(error){   
                            console.log(error);
                        }
                    }
                );
            },

            fn_checkDatabaseFile: function(businessId, callback){
                // let self = this;
                this.getData('CheckBusinessFileExists', businessId, 
                    {
                        onSuccess: function(response){
                            console.log(response);
                            callback(JSON.parse(response));
                        }, 
                        onError: function(error){
                            console.log(error);
                        }
                    }
                );
            },

            // fn_getRestoreFlag: function(businessId){
            //     let self = this;
            //     this.getData('GetRestoreFlag', null, 
            //     {
            //         onSuccess: function(response){
            //             console.log(response);
            //             if(response){
            //                 if(Number(response)==0){
            //                     self.fn_getPartialRestoredBusinessDetails(businessId);
            //                 }
            //                 else{
            //                     self.$root.fn_loadMainApp();
            //                 }
            //             }
            //         }, 
            //         onError: function(error){   
            //             console.log(error);
            //         }
            //     });
            // },

            // fn_getPartialRestoredBusinessDetails: function(businessId){
            //     let self = this;
            //     this.getData('AllBusiness', businessId, 
            //         {
            //             onSuccess: function(response){
            //                 console.log(response);
            //                 let data = JSON.parse(response);
            //                 if(data && data.currentBusiness){
            //                     self.$root.CurrentBusiness = data.currentBusiness;
            //                     self.$router.replace({path:'/registration/business/restore_data', query:{exitapp:1}});
            //                 }
            //             },
            //             onError: function(error){
            //                 console.log(error);
            //             }
            //         }
            //     );
            // },

            fn_goBack: function(type){
                console.log("Confirm Exit");
                // this.exitApp();
                if(type && type=='back'){
                    this.$router.go(-1);
                }
                else{
                   this.exitApp();
                }
            },

            // fn_test: function(){
            //     this.$root.fn_getLocalData('appLanguage', response=>{
            //         let language = JSON.parse(response);
            //         if(!language){
            //             this.$nextTick(() => { this.fn_openLanguageDialog(); });
            //         }
            //     });
            // }
        },  

        mounted: function(){

            window.js_globals.fn_onBackPress = this.fn_goBack;
            window.js_globals.fn_setOtp = this.fn_cancelSetOtp;

            let postObj = {"eventName":"app_open_biz_notregistered","eventData":[{"eventKey":"appopen","eventValue":"business_not_registered"}]}
            this.$root.fn_postMetrics(postObj);

            let formElement = document.getElementsByClassName("form-element")[0];

            formElement.addEventListener("submit", function(e){
                e.preventDefault();
            });

            // if(!localStorage.getItem('appLanguage')){
            //     this.$nextTick(() => { this.fn_openLanguageDialog(); });
            // }

            // this.$root.fn_getLocalData('appLanguage', response=>{
            //     if(!response || response=='null'){
            //         this.$nextTick(() => { this.fn_openLanguageDialog(); });
            //     }
            // });

            setTimeout(() => {
                const footer = document.querySelector('.v-footer');
                let initialHeight = window.innerHeight;

                window.addEventListener('resize', () => {
                    if (window.innerHeight < initialHeight - 100) {
                        // Keyboard is likely open
                        footer.style.position = 'static'; 
                    } else {
                        footer.style.position = 'fixed';
                        footer.style.bottom = '0';
                    }
                });
            }, 1000);
        },

        beforeRouteEnter (to, from, next) {
            console.log(from);
            next(vm => {
                // if(!from.name && from.path=='/'){
                if(from.name == 'languageView'){
                    console.log("Before ActiveBusinessStatus");
                    vm.fn_isBusinessActive();
                }
                else{
                    vm.trueCallerUser = false;
                }
            })
        }
    }
</script>